export default "__VITE_ASSET__Bfkm2hP5__"